import * as URI from 'urijs';

export const IMAGE_BASE_URL = 'img-wixmp-a9a8500ac7c5cd8136e17898.wixmp.com';
export const EDIT_MODE_SIZE = 48;
export const TABLE_HEADER_SIZE = 60;

export const getImageUrlWithDimensions = (imageUrl, size) => {
  if (imageUrl) {
    const retinaSize = size * 2;
    return isMediaPlatformUrl(imageUrl) ? `${imageUrl}::fil:${retinaSize}_${retinaSize}` : imageUrl;
  }
  return '';
};

const isMediaPlatformUrl = (imageUrl: string) => imageUrl.indexOf('wixmp.com') > -1;

export const createImageUrl = (imagePath: string) => `https://${IMAGE_BASE_URL}${imagePath}`;

export const getImagePath = (accountId: string, imageFileName: string) => {
  return `/${accountId}/${Date.now()}/${imageFileName}`;
};

const IMAGE_SIZE_REGEX = /::fil:.*/g;

export const getImageFileName = (accountId: string, imageUrl: string) => {
  const uri = new URI(imageUrl);
  if (uri.domain() === 'wixmp.com') {
    const lastSegment = decodeURIComponent(uri.segment().pop());
    return lastSegment.replace(IMAGE_SIZE_REGEX, '');
  } else {
    return '';
  }
};
